<!-- Navbar -->
<nav
  class="navbar navbar-main navbar-expand-lg mx-4 pt-3 pb-1 px-0 shadow-none border-radius-xl z-index-sticky"
  id="navbarBlur"
  *ngIf="global.organization"
  data-scroll="false"
>
  <div class="container-fluid pt-1 px-0" *ngIf="tokenPayload || mijnAssist">
    <div class="collapse navbar-collapse mt-sm-0 me-md-0 me-sm-4" id="navbar">
      <div class="zoeken d-none">
        <!-- TIJDELIJK ONZICHTBAAR GEMAAKT -->
        <div class="input-group">
          <span class="input-group-text text-body">
            <i class="fas fa-search" aria-hidden="true"></i>
          </span>
          <input type="text" class="form-control" placeholder="Zoeken..." />
        </div>
      </div>
      <ul class="navbar-nav justify-content-start">
        <li class="nav-item d-xl-none pe-3 d-flex align-items-center">
          <a (click)="toggleSidenav()"
             class="nav-link p-0"
             id="iconNavbarSidenav"
             class="btn bg-white px-2 py-1 my-auto"
             style="font-size: 1rem">
            <i class="fa-solid fa-angle-left pe-2" style="color: #344767"></i>Menu
          </a>
        </li>
        <li class="nav-item d-flex align-items-center pe-0" style="color: var(--header-font-color)">
          <span *ngIf="!mijnAssist" class="d-sm-inline d-none alert-link fs-4">
            {{ global.organization.Name }}
          </span>
          <span
            *ngIf="mijnAssist && global.organization"
            class="d-sm-inline d-none alert-link fs-4"
            >{{ name || "   " }}</span
          >
          <!--
                    <span *ngIf="mijnAssist && global.organization" class="d-sm-inline d-none alert-link fs-4">{{global.organization.Name || 'MijnAssist'}}</span>
                    -->
        </li>
      </ul>
    </div>
    <div class="collapse navbar-collapse m-0" id="navbar">
      <div class="ms-md-auto pe-md-3 d-flex align-items-center">
        <div class="input-group d-none">
          <span class="input-group-text text-body">
            <i class="fas fa-search" aria-hidden="true"></i>
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Type here..."
            onfocus="focused(this)"
            onfocusout="defocused(this)"
          />
        </div>
      </div>

      <ul class="navbar-nav justify-content-end">
        <div ngbDropdown class="d-inline-block" *ngIf="!mijnAssist">
          <a tabindex="0"
             role="button"
             class="nav-link dropdown-toggle dropdown-user font-weight-bold px-2"
             id="navbarDropDown"
             style="color: var(--header-font-color)"
             ngbDropdownToggle>
            <span *ngIf="!mijnAssist" class="d-sm-inline fs-5 pe-2">
              {{ tokenPayload?.FirstName }}
              <span class="d-sm-inline d-none">{{ tokenPayload?.LastName }}</span>
            </span>
            <span *ngIf="mijnAssist && global.member" class="d-sm-inline fs-5 pe-2">
              {{ global.member.Person.FirstName }}
              <span class="d-sm-inline d-none">{{ global.member.Person.LastName }}</span>
            </span>
          </a>
          <div
            *ngIf="!mijnAssist"
            class="dropdown-menu dropdown-menu-end navbar-dropdown-menu"
            ngbDropdownMenu
            aria-labelledby="navbarDropDown"
            style="z-index: -1"
            style="margin-top: 45px !important"
          >
            <a ngbDropdownItem class="dropdown-item" href="/">
              <i class="fa-solid fa-house text-primary text-sm opacity-10 pe-2"></i>Startpagina
            </a>
            <a *ngIf="global.organization.FederationId != federations.LokaleBesturen && !global.isWhiteLabelVsvw"
               ngbDropdownItem
               class="dropdown-item"
               (click)="showSubscription()">
              <img src="../../../../../assets/img/icons/icon_assist_new.png"
                   style="width: 15px" /><span class="d-inline-block ms-2 me-3">Mijn abonnement</span>
            </a>
            <a ngbDropdownItem class="dropdown-item" routerLink="/instellingen/account">
              <i class="fa-solid fa-user-gear text-primary text-sm opacity-10 pe-2"></i>Mijn gebruikersaccount
            </a>
            <a ngbDropdownItem class="dropdown-item" (click)="signout()">
              <i
                class="fa-solid fa-arrow-right-from-bracket text-primary text-sm opacity-10 pe-2"
              ></i
              >Afmelden
            </a>
          </div>
        </div>

        <div *ngIf="mijnAssist" ngbDropdown class="d-inline-block">
          <a
            tabindex="0"
            role="button"
            class="nav-link dropdown-toggle dropdown-user text-white font-weight-bold px-2"
            id="navbarDropDown"
            ngbDropdownToggle
          >
            <span class="d-sm-inline fs-5">
              <span class="d-inline-block ms-2 me-3">mijnAssist-account</span>
            </span>
          </a>

          <div
            *ngIf="auth?.isLoggedIn"
            class="dropdown-menu dropdown-menu-end navbar-dropdown-menu"
            ngbDropdownMenu
            aria-labelledby="navbarDropDown"
            style="z-index: -1; margin-top: 45px !important"
          >
            <a
              *ngFor="let person of userPersons"
              ngbDropdownItem
              class="dropdown-item"
              (click)="switchPerson(person)"
            >
              <i class="fa-solid fa-user text-primary text-sm opacity-10 pe-2"></i
              >{{ person.person.firstName }} {{ person.person.lastName }}
            </a>
            <a
              *ngIf="!personIsInUser"
              ngbDropdownItem
              class="dropdown-item"
              (click)="addPersonToUser()"
            >
              <i class="fa-solid fa-plus text-primary text-sm opacity-10 pe-2"></i>Toevoegen aan
              mijn account
            </a>
            <a ngbDropdownItem class="dropdown-item" (click)="swithOrg()">
              <i class="fa-solid fa-arrow-right-arrow-left text-primary text-sm opacity-10 pe-2"></i
              >Organisatie wisselen
            </a>
            <a ngbDropdownItem class="dropdown-item" (click)="auth?.logout()">
              <i
                class="fa-solid fa-arrow-right-from-bracket text-primary text-sm opacity-10 pe-2"
              ></i
              >Afmelden
            </a>
          </div>
          <div
            *ngIf="!auth?.isLoggedIn"
            class="dropdown-menu dropdown-menu-end navbar-dropdown-menu"
            ngbDropdownMenu
            aria-labelledby="navbarDropDown"
            style="z-index: -1; margin-top: 45px !important"
          >
            <a *ngIf="personOrMemberKey" ngbDropdownItem class="dropdown-item" (click)="register()">
              <i class="fa-solid fa-user-plus text-primary text-sm opacity-10 pe-2"></i>Activeren
            </a>
            <a ngbDropdownItem class="dropdown-item" (click)="signin()">
              <i class="fa-solid fa-arrow-right-to-bracket text-primary text-sm opacity-10 pe-2"></i
              >Aanmelden
            </a>
          </div>
        </div>
      </ul>
    </div>
  </div>
</nav>
<div class="mx-4" aria-label="breadcrumb">
  <ol class="breadcrumb bg-transparent mb-0 py-0 px-0 me-sm-6 me-5">
    <div *ngIf="!mijnAssist">
      <xng-breadcrumb></xng-breadcrumb>
    </div>
    <div *ngIf="mijnAssist">&nbsp;</div>
  </ol>
  <h2 *ngIf="!mijnAssist" class="font-weight-bolder mb-3 mt-5 text-white">
    {{ name || title}}
  </h2>
</div>
<!-- End Navbar -->
